<template>
  <!-- http://localhost:8080/#/Order/order/flowOrderBillRedFlush -->
  <div>
    <el-button @click="selects(1)">查询</el-button>
    <!-- 查询条件 -->
    <div style="width: 99%;">
      <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
        <el-descriptions-item label="查询房产">
          <el-autocomplete
            v-model="house"
            size="mini"
            style="width: 100%;"
            :fetch-suggestions="querySearchAsync"
            placeholder="可搜索房产"
            clearable
            @select="handleSelect"
          ></el-autocomplete>
        </el-descriptions-item>
        <el-descriptions-item label="客户名称">
          <el-input
            size="mini"
            v-model="data.name"
            clearable
            placeholder="客户名称"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="收费项">
          <el-select v-model="data.chargeitem_id" style="width: 100%" clearable size="mini" placeholder="收费项">
            <el-option
              v-for="item in chargeitem_name"
              :key="item.id"
              :label="item.chargeItem_name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item  label="类型">
          <RadioGroup v-model="data.moneyType">
            <Radio label="全部"></Radio>
            <Radio label="调整成功账单(流程结束后)"></Radio>
            <Radio label="调整不成功账单(流程结束后)"></Radio>
          </RadioGroup>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div style="width: 99%; margin-top: 10px;">
      <span>选中金额：<span style="color: red;">{{money_val}}</span>元</span>
      <span style="margin-left: 15px;">总金额：<span style="color: red;">{{money ? money : 0}}</span>元</span>
      <span style="margin-left: 15px;color: red;" v-if="loading_dade==2">加载中...</span>
      <div>
        <el-table ref="multipleTable" height="60vh" :data="orderData" border style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" > </el-table-column>
          <el-table-column prop="name" label="客户姓名" width="130">
            <template slot-scope="data">
              <el-tooltip class="item" effect="light" :content="data.row.customer_id" placement="right">
                <span>{{ data.row.name }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="house" label="房产" />
          <el-table-column prop="chargeitem_name" label="收费项目" width="130" />
          <el-table-column prop="money" label="金额" width="80" />
          <el-table-column prop="money" label="金额" width="80" />
          <el-table-column prop="payment_name" label="结算方式" />
          <el-table-column prop="date" label="添加时间" width="150"></el-table-column>
          <el-table-column prop="remark" label="备注" width="150"></el-table-column>
        </el-table>
      </div>
      <div class="pages">
        <el-pagination @size-change="selects_size"
                       @current-change="handleCurrentChange"
                       :current-page="page"
                       :page-sizes="[20,50,100,200,300,400,500]"
                       :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        activeName:'first',
        deposit_type: [],
        task_id:'',
        type:false,
        orderData:[],
        page:1,
        pageSize:20,
        total:0,
        chargeitem:[],
        chargeitem_name:[],
        name:"",
        chargeitems:[],
        order:[],
        money:0,
        money1:0,
        money2:0,
        money3:0,
        money_val:0,
        pid:'',
        house:'',
        loading_dade:1,
        number:'',
        data:{
          moneyType:'全部',
          select_charge_id:'',
          chargeItem_name_id:'',
          chargeItem_name_ids:'',
          startDate:'',
          endDate:''
        }
      }
    },
    created(){
       this.number = this.$route.query.number;
       this.selects(1);
    },
    components: {
      "erp-tree": () => import('../../Common/erp-tree-adiust.vue'),
      // "selectAdiust": () => import('./selectAdiust.vue'),
      "afterPaidFlow": () => import('./afterPaidFlow.vue'),
    },
    methods: {
        handleClick(tab, event) {
          console.log(tab, event);
        },
       handleSelect(){

       },
       //远程搜索方式
       querySearchAsync(query, cb) {
          if (query !== '') {
            this.loading_dade = 2;
            this.$myhttp.get('admin/common/house_name?house_name='+encodeURIComponent(query),{
              'Content-Type': 'application/json'
              }).then(backdata=>{ // 异步执行成功后
                this.loading_dade = 1;
                let selectList = backdata.data.data;
                let value = [];
                selectList.map(req=>{
                  value.push({'value':req.house})
                })
                cb(value)
            });
          }
       },
       handleSelectionChange(val){
        this.order = val;
        let money = 0;
        this.order.map(req=>{
            money = Number(money) + Number(req.money);
        })
        this.money_val = money.toFixed(2);
       },
       handleCurrentChange(e){
         this.page = e;//第几页
         this.selects(this.page);
       },
       selects_size(e){
         this.pageSize = e;
         this.selects(this.page);
       },
       // 查询
       selects(e){
         if(e){
           this.page = e;
         }
         this.chargeitems = [];
         this.data.chargeItem_name_id = '';
         this.data.chargeItem_name_ids = '';
         this.loading_dade = 2;
         let data = {'data':this.data,'house':this.house,'page':this.page,'pid':this.pid,'pageSize':this.pageSize,'number':this.number}
         this.$myhttp.post('admin/OrderBillRedFlushFlow/flowAdvanceIndex',data,{
           'Content-Type': 'application/x-www-form-urlencoded'
           }).then(backdata=>{ // 异步执行成功后
             this.orderData = backdata.data.data;
             this.total = backdata.data.count;
             this.money = backdata.data.money;
             this.money1 = backdata.data.money1;
             this.money2 = backdata.data.money2;
             this.money3 = backdata.data.money3;
             this.chargeitem = backdata.data.charge;
             this.chargeitem_name = backdata.data.chargeitem_name;
             this.loading_dade = 1;
         },err=>{
           this.loading_dade = 1;
           this.$Message.error('请求异常!');
         });
       },
      //点击树
      nodeClick(data){
        this.pid = data.tree[0].pindex_id;
        let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
        this.house=tree_str;
        this.selects(this.page);
      },
    }
  }
</script>

<style>
  .pages{
    width: 100%;
    margin-top: 20px;
  }
  .ti{
    background-color: white;
  }
  .d-flex {
    display: flex;
  }
  .d-flex-left {
    margin-right: 10px;
    border-right: 1px solid #eee;
    padding-right: 10px;
    width: 250px;

  }
  .d-flex-right {
    flex: 1;
    overflow-x:hidden;
  }
  .text2{
    color: rgb(250, 248, 248);
  }
</style>

<style lang="scss" scoped>
  .right-main {
    display: flex;
    // overflow: auto;//体内容的滚动条
    flex: 1;
    background: #fff;
  }
</style>




// WEBPACK FOOTER //
// src/components/Admin/Order/order/flowOrderBillRedFlushAdvance.vue